module.exports = __webpack_public_path__ + "static/media/4.25674f14.jpg";